module.exports = __webpack_public_path__ + "static/media/3.3f70bfa3.png";